import { render } from "./MonitorTextWidget.vue?vue&type=template&id=bfc04358"
import script from "./MonitorTextWidget.vue?vue&type=script&lang=js"
export * from "./MonitorTextWidget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__